import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import styled from '@emotion/styled';
import Body2 from './Typography/Body/Body2';
import Headline5 from './Typography/Heading/Headline5';
import { ListItem } from './List';
import { ListItemDate } from './List/Styled';
import Skeleton from './SkeletonLoader/Skeleton';

export const EventListContainer = styled.div`
  .ais-Highlight__highlighted {
    background-color: #cacaca;
  }
`;

const StyledListItem = styled(ListItem)`
  && {
    padding: 16px 16px 16px 0;
  }
`;

const eventListItemPropertyTypes = {
  jsonLd: PropTypes.node.isRequired,
  day: PropTypes.string.isRequired,
  month: PropTypes.string.isRequired,
  title: PropTypes.string,
  interval: PropTypes.string,
  location: PropTypes.string,
  addressCountry: PropTypes.string,
  showLoader: PropTypes.bool,
  showDivider: PropTypes.bool,
};

type EventListItemProperties = InferProps<
  typeof eventListItemPropertyTypes
>;

export const EventListItem = ({
  jsonLd,
  day,
  month,
  title,
  interval,
  location,
  addressCountry,
  showLoader,
  showDivider,
}: EventListItemProperties) => {
  const showLoaderValue = showLoader ?? false;

  return (
    <StyledListItem
      className="fu-list-item-content"
      tag="div"
      showDivider={showDivider ?? false}
    >
      {!showLoaderValue && jsonLd}
      <ListItemDate
        day={day}
        month={month}
        showLoader={showLoaderValue}
      />
      <div>
        {showLoaderValue ? (
          <Skeleton variant="rectangular" width="100%">
            <Headline5 tag="h2">&nbsp;</Headline5>
          </Skeleton>
        ) : <Headline5 tag="h2">{title}</Headline5>}
        {showLoaderValue ? (
          <Skeleton variant="rectangular" width="100%">
            <Body2>&nbsp;</Body2>
          </Skeleton>
        ) : <Body2>{interval}</Body2>}
        {showLoaderValue ? (
          <Skeleton variant="rectangular" width="250px">
            <Body2>&nbsp;</Body2>
          </Skeleton>
        ) : (
          <Body2>
            {[location, addressCountry]
              .filter(Boolean).join(' ')}
          </Body2>
        )}
      </div>
    </StyledListItem>
  );
};

EventListItem.propTypes = eventListItemPropertyTypes;
